document.addEventListener("DOMContentLoaded", function () {
  const chatContainer = document.getElementById("chatbot-container");
  const input = document.getElementById("chatbot-text");
  const sendBtn = document.getElementById("chatbot-send");
  const messages = document.getElementById("chatbot-messages");
  const suggestions = document.getElementById("chatbot-suggestions");

  let chatHistory = [];
  let chatSessionId;

  sendBtn.addEventListener("click", () => sendMessage(input.value));
  input.addEventListener("keypress", (e) => {
    if (e.key === "Enter") sendMessage(input.value);
  });

  function sendMessage(text) {
    text = text.trim();
    if (!text) return;

    appendMessage(text, "user");
    chatHistory.push({ role: "user", content: text });
    input.value = "";
    suggestions.innerHTML = "";

    showLoader();

    fetch("https://shop-store.production.fitelo.net/ai/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        question: text,
        history: chatHistory,
        chatSessionId: chatSessionId,
        resultId: localStorage.getItem("resultId"),
        resultAnswers: localStorage.getItem("resultAnswers"),
        pageUrl: window.location.href,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        hideLoader();
        chatSessionId = data.data.chatSessionId;
        appendMessage(data.data.reply, "bot");
        chatHistory.push({ role: "assistant", content: data.data.reply });
        showSuggestions(data.data.suggestions || []);
      })
      .catch(() => {
        hideLoader();
        appendMessage("Sorry, something went wrong.", "bot");
      });
  }

  function appendMessage(text, sender) {
    const msg = document.createElement("div");
    msg.className = `chatbot-message chatbot-${sender}`;
    msg.textContent = text;
    messages.appendChild(msg);

    // Scroll to bottom after a slight delay to ensure rendering
    setTimeout(() => {
      messages.scrollTop = messages.scrollHeight;
    }, 50);
  }

  function showSuggestions(suggestedQuestions) {
    suggestions.innerHTML = "";
    suggestedQuestions.forEach((q) => {
      const btn = document.createElement("button");
      btn.textContent = q;
      btn.onclick = () => sendMessage(q);
      suggestions.appendChild(btn);
    });
  }

  function showLoader() {
    hideLoader(); // remove existing if any
    const loader = document.createElement("div");
    loader.id = "chatbot-loader";
    loader.className = "chatbot-message chatbot-bot";
    loader.innerHTML = `<em>FitBot is typing...</em>`;
    messages.appendChild(loader);
    messages.scrollTop = messages.scrollHeight;
  }

  function hideLoader() {
    const existing = document.getElementById("chatbot-loader");
    if (existing) existing.remove();
  }

  // Starter suggestions
  showSuggestions([
    "How will this combo help me?",
    "Is it safe to consume?",
    "In how many days can I see results?",
  ]);
});
